export function resolveApiUrl(mode, settings = {}) {
  if (mode === 'development') return (settings.development || 'http://localhost:5000').replace(/\/$/, '');
  const configured = settings.production || settings.legacy || '';
  // A development .env must never send production users to their own localhost.
  if (/^https?:\/\/(localhost|127\.0\.0\.1|\[::1\])(?=[:/]|$)/i.test(configured)) return '';
  return configured.replace(/\/$/, '');
}
export const API_URL = resolveApiUrl(process.env.NODE_ENV, {
  development: process.env.REACT_APP_DEV_API_URL,
  production: process.env.REACT_APP_PRODUCTION_API_URL,
  legacy: process.env.REACT_APP_API_URL,
});
